<template>
  <iframe
    style="height:100%; width:100%; text-align:center; min-height:400px; max-height:100%"
    :src="location.product_sales_report"
    frameborder="0"
    width="100%"
    height="100%"
    allowtransparency
  ></iframe>
</template>

<script>
  export default {
    props: {
      location: Object
    }
  }
</script>




// WEBPACK FOOTER //
// src/components/Common/Rental/Locations/ProductSales.vue